import { render, staticRenderFns } from "./BtnMostrarConteudo.vue?vue&type=template&id=1868fc64&scoped=true"
import script from "./BtnMostrarConteudo.vue?vue&type=script&lang=js"
export * from "./BtnMostrarConteudo.vue?vue&type=script&lang=js"
import style0 from "./BtnMostrarConteudo.vue?vue&type=style&index=0&id=1868fc64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1868fc64",
  null
  
)

export default component.exports